module.exports = __webpack_public_path__ + "3790bfe8d8b600cb3597d72914caf1e4.png";


//////////////////
// WEBPACK FOOTER
// ./work/animalz/img/mid.png
// module id = 598
// module chunks = 0